import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Navigate, useParams } from "react-router";
export function LegacyPatientRecordsDetailsRedirect() {
    const { recordType, id } = useParams();
    return _jsx(Navigate, { to: `/patient-records-details/${recordType}/${id}`, replace: true });
}
